import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-radio-1-6-0{position:relative}.hcr-radio__label-1-6-0{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;min-height:30px;padding-left:42px;cursor:pointer}.hcr-radio__label-1-6-0:before{display:block;position:absolute;top:0;left:0;width:30px;height:30px;border:2px solid #c8c8c8;border-radius:100%;content:\"\"}.hcr-radio__input-1-6-0{position:absolute;opacity:0}.hcr-radio__input-1-6-0:focus+.hcr-radio__label-1-6-0:before{outline:1px solid transparent;-webkit-box-shadow:0 0 3px #00b5e2;box-shadow:0 0 3px #00b5e2}.hcr-radio__input-1-6-0:checked+.hcr-radio__label-1-6-0:before{border-color:#73d700}.hcr-radio__info-1-6-0{color:#444;font-size:14px;font-weight:300;line-height:17px;display:block;padding-top:3px}.hcr-radio--disabled-1-6-0 .hcr-radio__label-1-6-0{cursor:not-allowed;opacity:.5}.hcr-radio--error-1-6-0 .hcr-radio__label-1-6-0:before{border-color:#ff5700}.hcr-radio--error-1-6-0 .hcr-radio__info-1-6-0{color:#c64300}.hcr-radio__input-1-6-0:checked+.hcr-radio__label-1-6-0:after{display:block;position:absolute;top:7px;left:7px;width:16px;height:16px;border-radius:100%;background:#73d700;content:\"\";-webkit-animation:radio-grow .25s;animation:radio-grow .25s}@-webkit-keyframes radio-grow{0%{-webkit-transform:scale(.25);transform:scale(.25)}50%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes radio-grow{0%{-webkit-transform:scale(.25);transform:scale(.25)}50%{-webkit-transform:scale(1);transform:scale(1)}}",
map:{"hcr-radio":"hcr-radio-1-6-0","hcr-radio__label":"hcr-radio__label-1-6-0","hcr-radio__input":"hcr-radio__input-1-6-0","hcr-radio__info":"hcr-radio__info-1-6-0","hcr-radio--disabled":"hcr-radio--disabled-1-6-0","hcr-radio--error":"hcr-radio--error-1-6-0"}};

var bem = Bem('radio', styles);
var Radio = function Radio(_ref) {
  var extraClasses = _ref.extraClasses,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      value = _ref.value,
      disabled = _ref.disabled,
      valid = _ref.valid,
      info = _ref.info,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "id", "label", "name", "value", "disabled", "valid", "info"]);

  return React.createElement("div", {
    className: bem.b({
      disabled: disabled,
      error: valid === false
    }, extraClasses)
  }, React.createElement("input", _extends({
    id: id,
    className: bem.e('input'),
    name: name,
    type: "radio",
    disabled: disabled,
    value: value
  }, rest)), label && React.createElement("label", {
    htmlFor: id,
    className: bem.e('label')
  }, label), info && React.createElement("span", {
    className: bem.e('info')
  }, info));
};
Radio.displayName = 'Radio';
Radio.defaultProps = {
  extraClasses: '',
  disabled: null,
  valid: null,
  info: null
};
Radio.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Id for this radio, also used "for" label */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Name for this radio, required */
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Value for this radio */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Disables the input if set */
  disabled: PropTypes.bool,

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** Provides extra information for this input field */
  info: PropTypes.string
};
var radio = Injecss(Radio, styles);

export { radio as Radio };
